import React, { useState } from 'react';

function UiPreview() {
  const [isActive, setIsActive] = useState(false);

  return (
    <main
      style={{
        minHeight: '100vh',
        background: 'var(--figma-base)',
        padding: '32px',
        fontFamily: 'TT Norms Pro, sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: '900px',
          margin: '0 auto',
          border: '1px solid var(--color-border)',
          borderRadius: '20px',
          padding: '24px',
        }}
      >
        <p style={{ margin: '0 0 16px', color: 'var(--color-heading-muted)', fontSize: '14px' }}>
          Хобби
        </p>

        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <button type="button" className="interest-chip">
            Хоббихорсинг
          </button>

          <button
            type="button"
            className="interest-chip"
            aria-pressed={isActive}
            onClick={() => setIsActive((prev) => !prev)}
          >
            {isActive ? 'Настолки (active)' : 'Настолки'}
          </button>

          <button type="button" className="interest-chip interest-chip--active">
            Фотография
          </button>
        </div>
      </div>
    </main>
  );
}

export default UiPreview;
